import { permissionRepo } from '../repo';

export const permissionService = {
    async getAll(params = {}) {
        try {
            const response = await permissionRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getGrouped() {
        try {
            const response = await permissionRepo.getGrouped();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getModules() {
        try {
            const response = await permissionRepo.getModules();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(id) {
        if (!id) {
            throw new Error('Permission ID is required');
        }
        try {
            const response = await permissionRepo.getById(id);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getUsersWithPermissions(params = {}) {
        try {
            const response = await permissionRepo.getUsersWithPermissions(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getUserPermissions(userlogId) {
        if (!userlogId) {
            throw new Error('Userlog ID is required');
        }
        try {
            const response = await permissionRepo.getUserPermissions(userlogId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getAvailable() {
        try {
            const response = await permissionRepo.getAvailable();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async check(data) {
        if (!data.userlogId || !data.permission_name) {
            throw new Error('Userlog ID and Permission Name are required');
        }
        try {
            const response = await permissionRepo.check(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async assign(data) {
        if (!data.userlogId || !data.permissionId) {
            throw new Error('Userlog ID and Permission ID are required');
        }
        try {
            const response = await permissionRepo.assign(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async revoke(data) {
        if (!data.userlogId || !data.permissionId) {
            throw new Error('Userlog ID and Permission ID are required');
        }
        try {
            const response = await permissionRepo.revoke(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async sync(userlogId, permissionIds) {
        if (!userlogId) {
            throw new Error('Userlog ID is required');
        }
        if (!permissionIds || !Array.isArray(permissionIds)) {
            throw new Error('Permission IDs array is required');
        }
        try {
            const response = await permissionRepo.sync(userlogId, permissionIds);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('PermissionService Error:', error);
        return error.response?.data || error;
    },
};